import { create, read, remove, update } from "@/api/rest";

const projectTask = {
  create: async (data) => await create('/project-task', data),
  update: async (id, data) => await update(`/project-task/${id}`, data),
  remove: async (id) => await remove(`/project-task/${id}`),
  view: async (id) => await read(`/project-task/${id}`),
};

export default projectTask;